import { graphql, useStaticQuery } from 'gatsby'
import '@src/data/prismic-fragments/region'
import { Region, regionResolver } from '../utils/resolvers'

export default (): Region[] => {
  const data = useStaticQuery(graphql`
    {
      allPrismicRegion(sort: { fields: data___order }) {
        nodes {
          ...prismicRegionFragmentFull
        }
      }
    }
  `)

  return data.allPrismicRegion.nodes.map((node: any) => regionResolver(node))
}
